import { StarRating } from "./StarRating";
import { formatDate } from "@/lib/format";
import type { PublicReview } from "@/types";

export function ReviewCard({ review }: { review: PublicReview }) {
  return (
    <article className="rounded-lg border border-neutral-200 p-4">
      <header className="flex items-center justify-between gap-3">
        <div>
          <div className="font-medium">{review.displayName}</div>
          <div className="text-xs text-neutral-500">{formatDate(review.createdAt)}</div>
        </div>
        <StarRating value={review.rating} readOnly size="sm" />
      </header>
      <p className="mt-3 whitespace-pre-wrap text-sm text-neutral-800">{review.reviewText}</p>
      {review.therapistReply ? (
        <aside className="mt-3 rounded-md bg-neutral-50 p-3 text-sm">
          <div className="font-medium text-neutral-700">Odgovor terapeuta</div>
          <p className="mt-1 whitespace-pre-wrap text-neutral-800">{review.therapistReply}</p>
          {review.therapistReplyAt ? (
            <div className="mt-1 text-xs text-neutral-500">{formatDate(review.therapistReplyAt)}</div>
          ) : null}
        </aside>
      ) : null}
    </article>
  );
}
